import React, { Fragment, Component } from 'react'
import { accessRole } from '../../../../helpers/access_role'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'
import CustomSelect from '../../GlobalComponents/CustomSelect'

// const peg_uuid = JSON.parse(localStorage.getItem('userdata'))?.pegawai_uuid ?? "";
let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";
  let peg_name = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_name : "";
  let employee_current_position_name = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_current_position_name : "";
  if(accessRole('approve')){
      peg_uuid = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_uuid : "";
      peg_name = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_name : "";
      employee_current_position_name = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_current_position_name : "";
  }

var reformatOptionRegion = function(regions) {
  return regions.map(function(region) {
    var newObj = {};
    newObj["label"] = region.region_name;
    newObj["value"] = region.region_uuid;

    return newObj;
  });
};

var reformatOptions = function(raw, label, value) {
    return raw.map(function(data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
  
      return newObj;
    });
  };

class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            optionGender : [
              { label: "Dinas Luar", value: "Dinas Luar" },
              { label: "Tugas Belajar", value: "Tugas Belajar" }
            ],
            optionNational : [
                { label: "Dalam Negeri", value: "Dalam Negeri" },
                { label: "Luar Negeri", value: "Luar Negeri" }
              ],
            selectedGender: "",
            birthOptionCountry: [],
            birthSelectedCountry: "9da7d06b-b10c-4e28-a543-3442cc0f0182", // Sekertaris Utama
            birthOptionProvince : [],
            birthSelectedProvince: "",
            birthOptionCity : [],
            birthSelectedCity: ""
        }
    }

    // Select Area

    handleBirthSelectCountry = (birthSelectedCountry) => {
        let selected = birthSelectedCountry.value;
        this.getBirthProvinceByCountry(selected);
    }

    getBirthProvinceByCountry(selected_uuid){
        this.createBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            birthOptionProvince: reformatOptions(
                                response.result, 
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.fetchRegionProvince({
          //is_local: 1,
          parent_uuid : selected_uuid,
          type : 2  
        })
    }


    handleBirthSelectProvince = (birthSelectedProvince) => {
      this.setState({
        birthSelectedProvince: birthSelectedProvince.value
      });

      // get data city where province selected
      this.createBloc.regionCityChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      //console.log(response)
                      
                      this.setState({
                          birthOptionCity: reformatOptionRegion(response.result)
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      this.createBloc.fetchRegionCity({
        is_local: 1,
        type : 3,
        parent_uuid : birthSelectedProvince.value
      })
    }

    handleBirthSelectCity = (birthSelectedCity) => {
      this.setState({
        birthSelectedCity: birthSelectedCity.value
      });
    }

    handleSelectGender = (selectedGender) => {
      this.setState({
        selectedGender: selectedGender.value
      });
    }

    // End Select Area

    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              employee_uuid : peg_uuid,
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        // get data birth country
        this.createBloc.regionCountryChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            birthOptionCountry: reformatOptions(
                                response.result, 
                                'signatories_official_position',
                                'signatories_official_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.fetchRegionCountry({
          type : 1  
        })

        this.getBirthProvinceByCountry(this.state.birthSelectedCountry);

        // get data province
        this.createBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            birthOptionProvince: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.fetchRegionProvince({
          is_local: 1,
          type : 2  
        })
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="riwayatpenugasan"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Tambah Data Riwayat Penugasan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Penugasan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <CustomSelect 
                                                    name="assignment_history_type"
                                                    errorMessage="Pilih Jenis Penugasan"
                                                    options={this.state.optionGender} 
                                                    placeholder="Pilih Jenis Penugasan"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Tugas <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <CustomSelect 
                                                    name="assignment_history_type_national"
                                                    errorMessage="Pilih Jenis Tugas"
                                                    options={this.state.optionNational} 
                                                    placeholder="Pilih Jenis Tugas"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Mulai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_start_date"
                                                    placeholder="Tanggal Mulai..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Mulai"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_start_date"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Selesai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_end_date"
                                                    placeholder="Tanggal Selesai..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Selesai"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_end_date"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Penugasan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_number"
                                                    placeholder="Nomor Penugasan..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Penugasan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_number"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Penugasan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_date"
                                                    placeholder="Tanggal penugasan..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal penugasan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_date"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="tempat_lahir"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabat Penetap <span className="text-danger">*</span>
                                            </label>
                                            {/* <Col md="5">
                                                <CustomSelect 
                                                    name="assignment_history_approved_uuid"
                                                    errorMessage="Pilih Pejabat Penetap"
                                                    onChange={this.handleBirthSelectCountry}
                                                    options={this.state.birthOptionCountry} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Pejabat Penetap"
                                                    defaultValue={this.state.birthSelectedCountry}
                                                />
                                            </Col> */}
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_approved_uuid"
                                                    placeholder="Pejabat penetap..."
                                                    type="text"
                                                    errorMessage="Masukkan Pejabat penetap"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_approved_uuid"
                                                />
                                            </Col>
                                            <Col md="5">
                                                <AvField
                                                    name="peg_uuid"
                                                    placeholder="Pejabat penetap..."
                                                    type="hidden"
                                                    errorMessage="Masukkan Pejabat penetap"
                                                    className="form-control"
                                                    value={peg_uuid}
                                                    id="peg_uuid"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Sumber Pembiayaan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_cost_reference"
                                                    placeholder="Sumber Pembiayaan..."
                                                    type="text"
                                                    errorMessage="Masukkan Sumber Pembiayaan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_cost_reference"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Keterangan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_desc"
                                                    placeholder="Keterangan..."
                                                    type="text"
                                                    errorMessage="Masukkan Keterangan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_desc"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Kegiatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_activity_type"
                                                    placeholder="Jenis Kegiatan..."
                                                    type="text"
                                                    errorMessage="Masukkan Jenis Kegiatan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_activity_type"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tempat Organisasi Penyelenggara <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_place"
                                                    placeholder="Tempat Organisasi Penyelenggara..."
                                                    type="text"
                                                    errorMessage="Masukkan Tempat Organisasi Penyelenggara"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_place"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Lama (hari) <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_long_time"
                                                    placeholder="Lama (hari)..."
                                                    type="text"
                                                    errorMessage="Masukkan Lama (hari)"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_long_time"
                                                />
                                            </Col>
                                        </Row>
                                        

                                        

                                        
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                                                    <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                                                </AvCheckboxGroup>
                                                
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?riwayatpenugasan">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?riwayatpenugasan'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView